<template>
  <div>
    <!--动态将图片轮播图的容器高度设置成与图片一致-->
    <el-carousel :interval="4000" :height="bannerHeight + 'px'">
      <!--遍历图片地址,动态生成轮播图-->
      <el-carousel-item v-for="item in imgUrls" :key="item.id">
        <img :src="item.idView" alt />
      </el-carousel-item>
    </el-carousel>

    <div>
      <h3 style="font-size: 34px;">
        <span style="padding-bottom: 6px;border-bottom: 2px solid #133b95">产品业务</span>
      </h3>
    </div>
    <!-- <div class="header">
      <el-row type="flex" class="row-bg" justify="space-around">
        <el-col :span="8" :offset="1">
          <div style="position: relative;" class="bg-image1">
            <div class="bg1">
              <div class="text">
                <div style="float: right;padding-right:4%">
                  <img style="width: 80%;border-radius: 50%" src="../../assets/img/bg/img1.png" />
                </div>
                <br />
                <br />
                <div style="color: black;">
                  <h3 style="font-size: 20px" id="ff">聚合支付技术服务</h3>
                  <p style="font-size:15px" id="gg">助力于：门店聚合收款，上级订货余额支付</p>
                </div>
              </div>
            </div>
          </div>
        </el-col>

        <el-col :span="8" :offset="2" :pull="1">
          <div style="position: relative;" class="bg-image2">
            <div class="bg1">
              <div class="text">
                <div style="float: right;padding-right:4%">
                  <img style="width: 80%;border-radius: 50%" src="../../assets/img/bg/img2.png" />
                </div>
                <br />
                <br />
                <div style="color: black;">
                  <h3 style="font-size: 20px" id="ff">互联网保险技术服务</h3>
                  <p style="font-size:15px" id="gg">助力于：互联网保险业务的系统建设</p>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" class="row-bg" justify="space-around">
        <el-col :span="8" :offset="1">
          <div style="position: relative;" class="bg-image3">
            <div class="bg1">
              <div class="text">
                <div style="float: right;padding-right:4%">
                  <img style="width: 80%;border-radius: 50%" src="../../assets/img/bg/img3.png" />
                </div>
                <br />
                <br />
                <div style="color: black;">
                  <h3 style="font-size: 20px" id="ff">消费金融技术服务</h3>
                  <p style="font-size:15px" id="gg">助力于：B端贷款及C端用户消费信贷业务</p>
                </div>
              </div>
            </div>
          </div>
        </el-col>

        <el-col :span="8" :offset="2" :pull="1">
          <div style="position: relative;" class="bg-image4">
            <div class="bg1">
              <div class="text">
                <div style="float: right;padding-right:4%">
                  <img style="width: 80%;border-radius: 50%" src="../../assets/img/bg/img4.png" />
                </div>
                <br />
                <br />
                <div style="color: black;">
                  <h3 style="font-size: 20px" id="ff">共享经济技术服务</h3>
                  <p style="font-size:15px" id="gg">助力于：共享经济政策下的服务平台</p>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div> -->

    <div class="productBusiness">
      <div>
        <div style="color: #fff;  width: 800px; line-height: 62px;">
          <!-- <h3 style="font-size: 30px" id="ff">共享经济技术服务</h3> -->
          <p style="font-size:20px" id="gg"> {{businessTxt}}</p>
        </div>
      </div>
      <div>
        <img style="width: 100%;border-radius: 50%" src="../../assets/img/bg/img4.png" />
      </div>
    </div>

<!-- 
    <el-row style="margin-top: 3%" class="bg-partner">
      <h3 style="float:left;margin-left:160px;margin-top:160px;font-size:350%">合作伙伴</h3>
      <div style="float:left;margin-left:-168px;margin-top:260px;width:225px;height:62px">
        <a href="http://www.icbc.com.cn/icbc/" target="_blank">
          <img style="border-radius:10px;height:62px" src="../../assets/img/partner/partner_1.jpg" />
        </a>
      </div>

      <div style="float:left;margin-left:-226px;margin-top:380px;width:225px;height:62px">
        <a href="https://render.mybank.cn/p/b/ix74nfky/index" target="_blank">
          <img style="border-radius:10px;height:62px" src="../../assets/img/partner/partner_2.jpg" />
        </a>
      </div>

      <div style="float:left;margin-left:-226px;margin-top:500px;width:225px;height:62px">
        <a href="http://www.ccb.com/cn/home/indexv3.html" target="_blank">
          <img style="border-radius:10px;height:62px" src="../../assets/img/partner/partner_3.jpg" />
        </a>
      </div>
      <div style="float:left;margin-left:80px;margin-top:280px;width: 4px;height: 260px; background: #e5e5e5;"></div>
      <div style="float:left;margin-left:83px;margin-top:300px;width:180px;height:52px">
        <a href="https://www.oppo.com/cn/" target="_blank">
          <img style="border-radius:10px;height:52px" src="../../assets/img/partner/partner_4.jpg" />
        </a>
      </div>
      <div style="float:left;margin-left:-182px;margin-top:383px;width:180px;height:52px">
        <a href="https://www.vivo.com.cn/" target="_blank">
          <img style="border-radius:10px;height:52px" src="../../assets/img/partner/partner_5.jpg" />
        </a>
      </div>

      <div style="float:left;margin-left:-184px;margin-top:468px;width:180px;height:52px">
        <a href="https://www.okii.com/" target="_blank">
          <img style="border-radius:10px;height:52px" src="../../assets/img/partner/partner_6.jpg" />
        </a>
      </div>
      <div style="float:left;margin-left:44px;margin-top:300px;width:180px;height:52px">
        <a href="https://www.oneplus.com/cn" target="_blank">
          <img style="border-radius:10px;height:52px" src="../../assets/img/partner/partner_9.jpg" />
        </a>
      </div>
      <div style="float:left;margin-left:-180px;margin-top:380px;width:180px;height:52px">
        <a href="https://www.realme.com/cn/" target="_blank">
          <img style="border-radius:10px;height:52px" src="../../assets/img/partner/partner_7.jpg" />
        </a>
      </div>
      <div style="float:left;margin-left:-180px;margin-top:468px;width:180px;height:52px">
        <a href="https://www.vivo.com.cn/vivo/iqoo/" target="_blank">
          <img style="border-radius:10px;height:52px" src="../../assets/img/partner/partner_7.png" />
        </a>
      </div>
    </el-row> -->
    <!-- <el-row class="bg-ask" style="margin-top:-20px">
      <h3 style="font-size:300%;padding-top:40px;font-weight:400;color:white">立即咨询TENSER服务</h3>
      <div>
        <edit-form @confirm="openNotification" ref="edit"></edit-form>
      </div>
    </el-row> -->
 <div style="background-color:rgba(242, 242, 242, 1);height:500px;     margin-top: 50px;">
      <div style="float:left;padding-left:10%;width:30%;display: inline-block">
        <div style="padding-top:70px;">
          <img src="../../assets/img/bg/who.jpg" />
        </div>
      </div>
      <div style="float:right;width:50%;padding-right:10%;display: inline-block;">
        <div style="padding-top:60px;">
          <p style="font-size:40px;text-align:left;padding-left:40px;">
            我们是谁
            <span style="font-style: italic;font-size:50%">/WHO WE ARE</span>
          </p>
        </div>
        <!-- <div style="background-color:#0075E9;margin-bottom:60px;height:300px;width:80%;color:white"> -->

        <h3
          style="font-size:21px;padding-top:50px;padding-left:40px;padding-right:40px;text-align:left;font-weight:400;"
        > {{ aboutmeTxt}}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import EditForm from "./EditForm";
export default {
  name: "AppIndex1",
  components: {
    EditForm,
  },
  data() {
    return {
      // 图片父容器高度

      bannerHeight: 1070,
      aboutmeTxt:'',
      // 浏览器宽度
      websiteType:0,
      screenWidth: 0,
      imgUrls: [
        { id: 0, idView: require("../../assets/img/head/head1.jpg") },
        { id: 1, idView: require("../../assets/img/head/head2.jpg") },
        { id: 2, idView: require("../../assets/img/head/head3.jpg") },
        { id: 3, idView: require("../../assets/img/head/head4.jpg") },
        { id: 4, idView: require("../../assets/img/head/head5.jpg") },
      ],
      businessTxt:'',

    };
  },
  methods: {
    openNotification() {
      this.$message.success("您的留言我们已经收到，我们将尽快联系您", 5);
    },

    setSize: function () {
      // 通过浏览器宽度(图片宽度)计算高度

      this.bannerHeight = (520 / 1920) * this.screenWidth;
    },
  },
  created(){
  console.log(window.location.href);
      if(window.location.href.indexOf('ilegong.cn')>=0){
        this.websiteType =1;
      }else if(window.location.href.indexOf('hnwltech.com')>=0){
        this.websiteType =2;
      }else if(window.location.href.indexOf('hndaozheng.com')>=0){
        this.websiteType =3;
      }else{
        this.websiteType =0;
      }
   
      if(this.websiteType ==1){
          this.aboutmeTxt = 'Copyright 2018-2020 重庆乐工网络科技有限公司版权所有 |';
          this.businessTxt = '共享经济技术服务助力于：共享经济政策下的服务平台';

      }else if(this.websiteType ==2){
          this.aboutmeTxt = '湖南浯浪科技有限公司是厦门汇鑫聚集团有限公司（以下简称“汇鑫聚”）的二级子公司，专注于数字经济产业园运营的企业，园区企业业态主要有电子商务和新经济平台，其中新经济平台主要是灵活用工平台和网络货运平台。公司已在湖南、江西开展相关业务近5年，并准备在福建、贵州、安徽、广西等地落地相关业务。';
          this.businessTxt = '园区通过整合当地现有电子商务服务企业，使得园区具备电商孵化、客服中心、仓储物流及智慧云仓在内的电子商务全功能，解决当地企业物美价廉产品的销售、培养当地人员从事电商相关工作，与当地学校和企业合作研发产品、帮助学生就业；通过引入大型企业建设网络货运、灵活用工等新经济平台，解决企业痛点和当地税收等问题。';
        
      }else if(this.websiteType ==3){
          this.aboutmeTxt = '爱伙伴平台总部设立在深圳高新园，是中国合伙经济的倡导者，团队成员来自上市公司、人力资源公司、互联网公司和灵活用工企业。多年深耕于灵活用工行业，已在全国多地获得税局的委托代征资质，年营业额过亿，合作的客户有上市公司、互联网公司等。';
          this.businessTxt = '平台借助自身发展实力，与银行建立战略合作关系，直接打通API支付接口，保证合作企业资金支付高效、安全；平台打造了专业的灵活用工SAAS管理系统，全面实现业务流、合同流、资金流、票据流、信息流“五流合一” ，税务监管清晰透明，高质量满足国家税务局的监管要求；平台利用大数据技术手段与第三方技术平台合作，自动化、系统化实现身份验证、人脸识别、电子协议签署、资金支付、税款缴纳、票据开具等业务需求。';
        
      }else if(this.websiteType ==0){
          this.businessTxt = '共享经济技术服务助力于：共享经济政策下的服务平台';
          this.aboutmeTxt = '东莞市腾盛软件科技有限公司是专注为用户提供安全、便捷服务的科技公司，主要团队位于深圳。在业务上主要依托OPPO、vivo、小天才丰富的移动端线上交易场景及亿级C端用户，聚焦于提供互联网科技支持和服务，助力于打造健康、高效的互联网科技生态。';
        
      }
  },
  mounted() {
    // 首次加载时,需要调用一次

    this.screenWidth = window.innerWidth;

    this.setSize();

    // 窗口大小发生改变时,调用一次

    window.onresize = () => {
      this.screenWidth = window.innerWidth;

      this.setSize();
    };
  },
};
</script>

<style lang="less" scoped>
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

img {
  /*设置图片宽度和浏览器宽度一致*/

  width: 100%;

  height: inherit;
}
// .bg1 {
//   width: 285px;
//   height: 375px;

// }
.bg-image1 {
  // width: 715px;
  width: 100%;
  height: 190px;
}
.bg-image1 :hover {
  background: url(../../assets/img/bg/c1.jpg) no-repeat;
  // background-size: contain;
  background-size: 100% 100%;
  #ff {
    color: aliceblue;
  }
  #gg {
    color: aliceblue;
  }
}

.bg-image2 {
  // width: 715px;
  width: 100%;
  height: 190px;
}
.bg-image2 :hover {
  background: url(../../assets/img/bg/c2.jpg) no-repeat;
  // background-size: contain;
  background-size: 100% 100%;
  #ff {
    color: aliceblue;
  }
  #gg {
    color: aliceblue;
  }
}

.bg-image3 {
  // width: 715px;
  width: 100%;
  height: 190px;
}
.bg-image3 :hover {
  background: url(../../assets/img/bg/c3.jpg) no-repeat;
  // background-size: contain;
  background-size: 100% 100%;
  #ff {
    color: aliceblue;
  }
  #gg {
    color: aliceblue;
  }
}
.productBusiness{
  width: 100%;
  height: 380px;
  background: url(../../assets/img/bg/c4.jpg) no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  >div{
    text-align: left;
  }
}
.bg-image4 {
  width: 100%;
  /* height: 190px; */
  height: 380px;
  .bg1{
    width: 100%;
    height: 100%;
  }
}
.bg-image4:hover {
  background: url(../../assets/img/bg/c4.jpg) no-repeat;
  /* // background-size: contain; */
  background-size: 100% 100%;
  #ff {
    color: aliceblue;
  }
  #gg {
    color: aliceblue;
  }
}
.bg1 .text :hover {
  background-image: none;
  color: aliceblue;
}
.head-icon :hover {
  background-image: none;
  color: aliceblue;
}

.bg1 .text {
  padding-top: 109px;
  /* padding-top: 25px; */
  padding-bottom: 35px;
  color: #000000;
  text-align: left;
  padding-left: 13%;
  // overflow: hidden;
  // position: relative;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
  background-color: rgba(242, 242, 242, 1);
  // width: 715px;
  width: 100%;
}
.row-bg {
  padding: 10px 0;
}

.header {
  box-sizing: border-box;
  width: 100%;
  padding: 0 10px;
}
.bg-partner {
  // width: 1590px;
  height: 681px;
  // margin-left:10%;
  // margin-right:10%;
  background: url(../../assets/img/partner/partner.jpg) no-repeat;
  background-size: 100% 100%;
}
.bg-ask {
  // width: 1590px;
  height: 281px;
  //  margin-left:10%;
  //   margin-right:10%;
  background: url(../../assets/img/partner/yshbh1.jpg) no-repeat;
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/home/AppIndex1.vue